export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^[0-9]{2}-[0-9]{3}$/));
    }
}
